import { render, staticRenderFns } from "./ApprovalTemplate.vue?vue&type=template&id=eebd57ce"
import script from "./ApprovalTemplate.vue?vue&type=script&lang=ts"
export * from "./ApprovalTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\808325\\Documents\\SsmlockEntryReqWebApp-IVC202512\\SsmlockEntryReqWebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eebd57ce')) {
      api.createRecord('eebd57ce', component.options)
    } else {
      api.reload('eebd57ce', component.options)
    }
    module.hot.accept("./ApprovalTemplate.vue?vue&type=template&id=eebd57ce", function () {
      api.rerender('eebd57ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/ApprovalTemplate/ApprovalTemplate.vue"
export default component.exports